export default __webpack_public_path__ + "static/media/fill.6dde82af.svg";